import React from "react";
import { Card, CardBody, Spinner } from "reactstrap";
import round from "lodash/round";
import isNumber from "lodash/isNumber";

import "./StatCard.scss";

const StatCard = ({
  loading,
  title,
  value,
  ranges,
  percent,
  icon,
  onClick,
  onlyCardIcon,
  selected
}) => {
  if (loading) {
    return (
      <React.Fragment>
        <Card
          className="mini-stat bg-stat-card text-brand-navy mx-2"
          style={{ width: "8rem", height: "6rem", borderRadius: "1rem" }}
        >
          <CardBody className="d-flex justify-content-center align-items-center">
            <Spinner />
          </CardBody>
        </Card>
      </React.Fragment>
    );
  }

  if(onlyCardIcon) {
    return(
      <Card
        className="mini-stat bg-stat-card text-brand-navy mx-2"
        style={{ width: "8rem", height: "6rem", borderRadius: "1rem" }}
        onClick={onClick}
      >
        <CardBody className="p-1 d-flex flex-column align-items-center justify-content-center">
          <div className="d-flex justify-content-center my-1">
              {icon}
          </div>
          {selected && <div className="selected-card-indicator" />}
        </CardBody>
      </Card>
    )
  }

  let status, message;
  const validValue = isNumber(value);

  for (const r of ranges) {
    if (value >= r.low && value <= r.high) {
      status = r.status;
      message = r.message;
      break;
    }
  }

  let alertClassName = "alert fade show ";
  switch (status) {
    case "good":
      alertClassName += "alert-success";
      break;
    case "ok":
      alertClassName += "alert-info";
      break;
    case "warning":
      alertClassName += "alert-warning";
      break;
    case "bad":
      alertClassName += "alert-danger";
      break;
    default:
      break;
  }

  let labelClassName = "percent ";
  let arrowClassName = "mr-2 mdi ";
  if (!validValue || !percent) {
    labelClassName += "bg-dark text-light";
    arrowClassName += "d-none";
  } else {
    const percentValue = parseFloat(percent);
    if (percentValue >= 50) {
      labelClassName += "bg-warning";
      arrowClassName += "mdi-arrow-up text-success";
    } else if (percentValue > 0) {
      labelClassName += "bg-success";
      arrowClassName += "mdi-arrow-up text-success";
    } else if (percentValue === 0) {
      labelClassName += "bg-info";
      arrowClassName += "mdi-arrow-right text-info";
    } else {
      labelClassName += "bg-danger";
      arrowClassName += "mdi-arrow-down text-danger";
    }
  }

  return (
    <React.Fragment>
      <Card
        className="mini-stat bg-stat-card text-brand-navy mx-2"
        style={{ width: "8rem", height: "6rem", borderRadius: "1rem" }}
        onClick={onClick}
      >
        <CardBody className="p-1 d-flex flex-column align-items-center justify-content-center">
          <div className="d-flex justify-content-center my-1">
              {icon}
          </div>
          <div className="d-flex flex-column">
              <span className="text-[10px] font-bold text-uppercase mt-0 text-brand-gray-dark text-center tracking-wider">
                {title}
              </span>
              <span
                className="text-xl font-bold text-center text-brand-navy font-display"
              >
                <span>
                  <i className={arrowClassName} />
                </span>
                {validValue ? (
                  round(value, 2)
                ) : (
                  <em className="text-secondary text-center">Sin Datos</em>
                )}
              </span>
          </div>
          <div className="d-flex justify-content-center">
            {percent && (
              <div className={labelClassName}>{validValue ? percent : "-"}</div>
            )}
          </div>
          {selected && <div className="selected-card-indicator" />}
        </CardBody>
      </Card>
      {validValue && false && <div className={alertClassName}>{message}</div>}
    </React.Fragment>
  );
};

export default StatCard;
